<script setup lang="ts">
import BrandLogo from "@/components/BrandLogo.vue";

withDefaults(defineProps<{
  compact?: boolean;
  decorative?: boolean;
  size?: "default" | "large";
}>(), { compact: false, decorative: false, size: "default" });
</script>

<template>
  <span
    class="product-brand"
    :class="{ 'product-brand--compact': compact, 'product-brand--large': size === 'large' }"
    :role="decorative ? undefined : 'img'"
    :aria-label="decorative ? undefined : '云比特财务管理'"
    :aria-hidden="decorative ? true : undefined"
  >
    <BrandLogo :compact="compact" :width="size === 'large' ? 216 : 88" decorative />
    <span v-if="!compact" class="product-brand__divider" aria-hidden="true" />
    <span class="product-brand__name">{{ compact ? '财务' : '财务管理' }}</span>
  </span>
</template>

<style scoped>
.product-brand {
  --company-logo-width: 88px;
  --brand-gap: 10px;
  --brand-divider-height: 28px;
  --brand-name-size: 16px;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: var(--brand-gap);
  color: var(--ui-text);
  white-space: nowrap;
}

.product-brand :deep(.brand-logo) {
  width: var(--company-logo-width);
}

.product-brand__divider {
  width: 1px;
  height: var(--brand-divider-height);
  flex: 0 0 auto;
  background: var(--ui-border);
}

.product-brand__name {
  font-size: var(--brand-name-size);
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 0;
}

.product-brand--large {
  --company-logo-width: 216px;
  --brand-gap: 26px;
  --brand-divider-height: 54px;
  --brand-name-size: 37px;
}

@media (max-width: 1100px) {
  .product-brand--large {
    --company-logo-width: 120px;
    --brand-gap: 16px;
    --brand-divider-height: 32px;
    --brand-name-size: 24px;
  }
}

.product-brand--compact {
  --company-logo-width: 32px;
  --brand-name-size: 11px;
  flex-direction: column;
  gap: 6px;
}

.product-brand--compact .product-brand__name {
  line-height: 1;
  letter-spacing: 1px;
  text-indent: 1px;
}
</style>
